<div class="main">
    <div>
        <img src="assets/logos/logo.svg" alt="Capch logo">
    </div>
    <div class="card">
        <div class="header">Admin Login</div>
        <button pButton type="button" label="Login with Okta" (click)="login()" class="p-button-primary"></button>
    </div>
    <div class="footer">
        <div>Copyright © Artist Match</div>
    </div>
</div>